const ASSETS_BASE_URL = process.env.REACT_APP_ASSETS_URL || '';

export const resolveImageUrl = (url) => {
  if (!url) return '';
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('/images/')) return '';
  return ASSETS_BASE_URL ? `${ASSETS_BASE_URL}${url}` : url;
};

export const getPrimaryImage = (images = []) => {
  for (const img of images) {
    const resolved = resolveImageUrl(img?.url);
    if (resolved) return { url: resolved, altText: img?.altText || '' };
  }
  return { url: '', altText: '' };
};

export const getPrimaryImageUrl = (images = []) => getPrimaryImage(images).url;
